// GENERATED FILE, PLEASE DO NOT EDIT
var None = 0;
var Hairline = 1;
var Default = 1;
var Regular = 1;
var Medium = 2;
var Bold = 3;
var BorderWidthTokensAll = {
  Bold: Bold,
  Default: Default,
  Hairline: Hairline,
  Medium: Medium,
  None: None,
  Regular: Regular
};

export { Bold, BorderWidthTokensAll, Default, Hairline, Medium, None, Regular, BorderWidthTokensAll as default };
